<template>
  <div id="container">

    <section id="mypage">
      <div class="wrap">

        <div class="cts_box">
          <h3 class="child_ttl">クラス・支払い方法変更の申請をキャンセルしました</h3>
          <p class="lead_txt alnC sp_alnL">
            クラス・支払い方法変更の申請をキャンセルしました。
          </p>

          <div class="button_wrap">
            <router-link :to="{name: 'UsersCustomerTop'}" class="submit basic">複眼経済塾トップ</router-link>
          </div>
          <div class="button_wrap">
            <router-link :to="{name: 'UsersCustomerAccount'}" class="submit light skeleton">マイページ</router-link>
          </div>
        </div>

      </div>
    </section>

    <div id="b_listBox">
      <ul id="b_list">
        <li><router-link to="/">トップページ</router-link></li>
        <li><router-link :to="{name: 'UsersCustomerAccount'}">マイページ</router-link></li>
        <li>クラス・支払い方法変更の申請をキャンセルしました</li>
      </ul>
    </div>

  </div>
</template>

<script>

import Libraries from '@/components/Libraries'

export default {
  mixins: [Libraries]
}
</script>
